<template>
  <div class="creat-return-99">
    <div v-if="dataPermission && dataPermission.includes('NSH_PARTNER_CUS_VIEW')">
      <Head @submit="submitForm">
        <template v-if="isReturnHasExchange" #header-left>
          <div v-if="statusActive != 0">
            <el-button class="n-btn" type="info" :disabled="getIsPayWithMpos" @click="statusActive--, scrollToTop()">Quay lại</el-button>
          </div>
        </template>
        <template v-if="isReturnHasExchange" #header-right>
          <div class="d-flex">
            <el-button class="ml-2 n-btn" type="primary" v-if="statusActive == 1 || statusActive == 0" @click="continueReturn">Tiếp tục</el-button>
            <el-button :disabled="getIsPaying" class="ml-2 n-btn" type="primary" v-if="statusActive == 2" @click="confirmReturn"
              >Xác nhận đơn</el-button
            >
          </div>
        </template>
      </Head>

      <div class="boxContent boxContentExt">
        <div class="row justify-content-center my-4" v-show="isReturnHasExchange">
          <div class="col-8">
            <el-steps class="n-steps" :active="statusActive" align-center>
              <el-step
                v-for="(status, index) in statusOrder"
                :key="index"
                :title="status.title"
                :description="status.description"
              >
              </el-step>
            </el-steps>
          </div>
        </div>

        <template v-if="statusActive == 0">
          <!-- Thông tin đơn mua hàng -->
          <div class="__card__order-return">
            <h1 class="__card__order-return_title">Thông tin đơn mua hàng</h1>
            <el-form label-width="140px" style="width: 100%;">
              <el-form-item label="Mã đơn hàng">
                <el-row :gutter="30">
                  <el-col :span="5">
                    <strong>{{ dataItem.orderNo }}</strong>
                  </el-col>
                  <a @click="SODetail" class="text-primary cursor">
                    <i class="fa-solid fa-up-right-from-square"></i> Đi đến đơn hàng
                  </a>
                </el-row>
              </el-form-item>

              <el-form-item label="Khách hàng">
                <el-row :gutter="30">
                  <el-col :span="10">
                    <strong v-if="dataItem.partyB">{{ dataItem.partyB.displayName }}</strong>
                  </el-col>
                  <el-col :span="5">Ngày mua</el-col>
                  <el-col :span="5">{{ this.timeFormatDate(dataItem.createdAt) }}</el-col>
                </el-row>
              </el-form-item>

              <el-form-item label="Chi nhánh">
                <el-row :gutter="30">
                  <el-col :span="10">
                    <strong>{{ branch | formatLocation }}</strong>
                  </el-col>
                  <el-col :span="5">Nhân viên bán hàng</el-col>
                  <el-col :span="5" v-if="dataItem.partyA">{{
                    dataItem.partyA.displayName ? dataItem.partyA.displayName : "---"
                  }}</el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>

          <!-- Thông tin đơn trả -->
          <div class="__card__order-return mt-3">
            <h1 class="__card__order-return_title">Thông tin đơn trả</h1>
            <el-form label-width="140px" style="width: 100%;">
              <el-row :gutter="20">
                <el-col :span="12" :lg="12" :md="12" :xs="24">
                  <el-form-item label="Người tạo đơn">
                    <el-input v-model="inforAccount.name" disabled />
                  </el-form-item>
                  <el-form-item label="Khách trả hàng">
                    <el-select
                      v-if="listCustomer.length"
                      filterable
                      remote
                      reserve-keyword
                      v-model="customer.resId"
                      placeholder="Khách vãng lai"
                      class="w-100"
                    >
                      <el-option value="" >
                        <div class="option-add-info d-flex align-items-center"  @click.stop="showModalAddCustomerNew = true">
                          <i class="bx bx-plus text-primary fz-18"></i>
                          <el-button
                            type="text"
                            class="text-primary font-weight-bold fz-14"
                          >
                            Thêm mới khách hàng
                          </el-button>
                        </div>
                      </el-option>
                      <el-option
                        class="option-add-item"
                        v-for="item in listCustomer"
                        :key="item.id"
                        :label="item.text"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" :lg="12" :md="12" :xs="24">
                  <el-form-item label="Ngày tạo">
                    <el-input disabled :value="nowTime" />
                  </el-form-item>
                  <el-form-item label="Lý do trả">
                    <el-input
                      v-model="returnReasonOther"
                      v-if="returnOrderParams.returnReason === 'Khác'"
                      placeholder="Nhập lý do trả hàng..."
                    >
                      <el-button slot="append" icon="el-icon-arrow-down" @click="returnOrderParams.returnReason = ''"></el-button>
                    </el-input>
                    <el-select
                      v-else
                      v-model="returnOrderParams.returnReason"
                      placeholder="Chọn lý do trả hàng"
                      class="m-2 w-100 return-reason"
                    >
                      <el-option v-for="item in reasonReturnList" :key="item.id" :label="item.text" :value="item.text">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="18" :lg="18" :md="18" :xs="18">
                  <el-form-item label="Mã tham chiếu">
                    <el-input v-model="returnOrderParams.referenceCode" placeholder="Nhập mã tham chiếu" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="18" :lg="18" :md="18" :xs="18">
                  <el-form-item label="Ghi chú">
                    <el-input v-model="returnOrderParams.note" type="textarea" placeholder="Nhập ghi chú" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="18" :lg="18" :md="18" :xs="18">
                  <el-form-item label="Đổi hàng">
                    <el-switch v-model="isReturnHasExchange" active-text="Trả có đổi hàng"></el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>

          <!-- Sản phẩm trả -->
          <div class="__card__order-return mt-3">
            <h1 class="__card__order-return_title">Sản phẩm trả</h1>
            <el-form class="mb-2" @submit.native.prevent style="width: 100%;">
              <el-row :gutter="16">
                <el-col :span="19" :lg="19" :md="19" :xs="19">
                  <div class="search-form">
                    <el-input
                      v-model="search"
                      @input="searchProductDebounce"
                      @keypress.enter.native="searchProduct"
                      placeholder="Tìm kiếm sản phẩm theo tên hoặc mã SKU"
                      clearable
                      @clear="removeTextSearch"
                      style="width: 100%;"
                    ></el-input>
                    <svg
                      class="search-form_icon"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.53223 14.0332C8.92969 14.0332 10.2393 13.6113 11.3291 12.8906L15.1787 16.749C15.4336 16.9951 15.7588 17.1182 16.1104 17.1182C16.8398 17.1182 17.376 16.5469 17.376 15.8262C17.376 15.4922 17.2617 15.167 17.0156 14.9209L13.1924 11.0801C13.9834 9.95508 14.4492 8.59277 14.4492 7.11621C14.4492 3.31055 11.3379 0.199219 7.53223 0.199219C3.73535 0.199219 0.615234 3.31055 0.615234 7.11621C0.615234 10.9219 3.72656 14.0332 7.53223 14.0332ZM7.53223 12.1875C4.74609 12.1875 2.46094 9.90234 2.46094 7.11621C2.46094 4.33008 4.74609 2.04492 7.53223 2.04492C10.3184 2.04492 12.6035 4.33008 12.6035 7.11621C12.6035 9.90234 10.3184 12.1875 7.53223 12.1875Z"
                        fill="#808890"
                      />
                    </svg>
                  </div>
                </el-col>
                <el-col :span="5" :lg="5" :md="5" :xs="5">
                  <el-popover trigger="click" width="200" v-model="showQuickHandle">
                    <el-button slot="reference" class="w-100 btn-fix-sỉze">Thao tác nhanh</el-button>
                    <div class="quick-handle">
                      <div class="quick-handle_btn" @click="handleSelectAll">Trả tất cả</div>
                      <div class="quick-handle_btn text-danger" @click="handleSelectNo">Bỏ chọn</div>
                    </div>
                  </el-popover>
                </el-col>
              </el-row>
            </el-form>

            <!-- table chọn sp hoàn -->
            <b-table :items="productsSearchData" :fields="fields" :key="updateUI" show-empty>
              <template #empty>
                <EmptyTable></EmptyTable>
              </template>
              <template #cell(stt)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(sku)="data">
                {{ data.item.itemInstance.moreInformation.sku }}
              </template>
              <template #cell(quantityVal)="data">
                <span class="d-flex align-items-center">
                  <el-input-number  class="mr-2" style="width: 100px;" v-model="data.item.quantityVal" controls-position="right" @change="checkToDeleteAllReturn('số lượng')"      
                    :min="0" :max="data.item.quantity"
                    :disabled="data.item.useProductBatch === true || data.item.useImeiAndSerial === true"
                  ></el-input-number>
                  <div> /{{ data.item.quantity }}</div>
                </span>
              </template>
              <template #cell(itemName)="data">
                {{ data.item.itemInstance.name }}
              </template>
              <template #cell(price)="data">
                <el-popover
                  popper-class="popover-price-88"
                  placement="bottom"
                  width="350"
                  trigger="click"
                  content="this is content, this is content, this is content"
                >
                  <b-button
                    class="btn btn-fix-sỉze btn-popover w-100 text-right"
                    slot="reference"
                    triggers="click"
                    width="400"
                    variant="light"
                  >
                    {{ formatMoneyNotUnit(data.item.returnProductPrice) }}
                    <span v-if="getProductFreeValue(data.item) != 0" class="btn-popover_fee-price"
                      >-{{ formatMoney(getProductFreeValue(data.item)) }}</span
                    >
                  </b-button>
                  <div class="row d-flex align-items-center">
                    <div class="col-4">Đơn giá trả:</div>
                    <div class="col-8">
                      <InputMoneyVmodel
                        placeholder="Nhập số tiền..."
                        v-model="data.item.returnProductPrice"
                        @change="checkToDeleteAllReturn('giá')"
                        class="form-control"
                      >
                      </InputMoneyVmodel>
                    </div>
                    <div class="col-12">
                      <div class="row d-flex align-items-center mt-2">
                        <div class="col-4">Phí trả hàng:</div>
                        <div class="col-8">
                          <InputMoneyHaveFee
                            placeholder="Nhập số tiền..."
                            :arrayParent="data.item.productFreeArr"
                            :FeeKey="data.item.productFreeKey"
                            valueKey="value"
                            :max="data.item.returnProductPrice"
                            @change="checkToDeleteAllReturn('phí')"
                            @changeFeeKey="data.item.productFreeKey = $event"
                          ></InputMoneyHaveFee>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-popover>
              </template>
              <template #cell(total)="data"> {{ formatMoneyNotUnit(getProductPriceAddFree(data.item)) }} đ </template>

              <template #row-details="data">
                <!--Chọn số EMEI/se-ri: useImeiAndSerial-->
                <div class="line dataUseImeiAndSerial" v-if="data.item.useImeiAndSerial">
                  <div class="col-md-2 text-bold pull-left mt-2">IMEI/Serial <span class="text-red">*</span> :</div>
                  <div class="col-md-10 pull-left selectDT">
                    <div class="icon pointed-event-none"><i class="fa fa-chevron-down"></i></div>
                    <select2-multiple-control
                      @change="data.item.quantityVal = data.item.seriesNoTmp.length"
                      :options="data.item.getSeri"
                      v-model="data.item.seriesNoTmp"
                    />
                  </div>
                </div>

                <!--Chọn số Lo/HSD: useProductBatch-->
                <div class="line dataUseProductBatch" v-if="data.item.useProductBatch">
                  <div class="col-md-2 text-bold pull-left mt-2">Lô HSD <span class="text-red">*</span> :</div>
                  <div class="col-md-10 pull-left selectLoHsd">
                    <div class="line-lo-hsd">
                      <span class="item-lo-hsd" v-for="(itemBatch, indexBatch) in data.item.batchTmp" :key="indexBatch">
                        {{ itemBatch.batchCode }} - HSD: {{ convertDateItem(itemBatch.expirationDate) }} - SL:
                        {{ itemBatch.quantityVal }}
                        <i class="loHsd bx bx-x" @click="removeItemUseProductBatch(indexBatch, itemBatch, data.index)"></i>
                      </span>
                      <div class="lo-hsd-select" @click="loadDataUseProductBatch(data.index, data.item)">
                        <i class="fa fa-chevron-down"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </b-table>

            <div v-if="!refundPolicy && isReturnHasExchange" class="row w-100 d-flex justify-content-center my-2">
              <div class="col-10">
                <b-alert class="custom-alert m-0" show variant="warning text-dark">
                  Giá trị cần hoàn trả bằng 0 do cửa hàng đã bật cấu hình <b>“Không hoàn tiền khi đổi trả hàng”</b>.<br />
                  Để cài đặt lại, vui lòng đi tới
                  <b><router-link :to="{ path: '/setting/config' }">Cấu hình bán hàng</router-link></b>
                </b-alert>
              </div>
            </div>

            <div class="mt-3 w-100">
              <div class="row py-1">
                <div class="col-md-6">Đã chọn {{ getQuantity }} sản phẩm</div>
                <div class="col-md-6 text-right">
                  <div class="row">
                    <div class="col-md-6">Tạm tính</div>
                    <div class="col-md-6">{{ formatMoneyNotUnit(getTotalPrice) }} đ</div>
                  </div>
                </div>
              </div>
              <div class="row py-1">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-6">Đã nhận hàng trả</div>
                    <div class="col-md-6">
                      <el-switch v-model="isReceivedItem" active-text="Nhận hàng"> </el-switch>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 text-right">
                  <div class="row">
                    <div class="col-6">
                      <el-popover
                        popper-class="popover-price-88"
                        placement="bottom"
                        title="Nhập thêm phí"
                        width="400"
                        trigger="click"
                        content="this is content, this is content, this is content"
                      >
                        <b-button
                          slot="reference"
                          style="height: auto;"
                          class="btn-link text-primary"
                          id="popover-target-free-return"
                          :disabled="!refundPolicy || getTotalPrice == 0"
                        >
                          Phí trả hàng
                          <i class="el-icon-circle-plus-outline"></i>
                        </b-button>
                        <div class="row d-flex align-items-center">
                          <div class="col-4">Phí trả hàng:</div>
                          <div class="col-8">
                            <InputMoneyHaveFee
                              placeholder="Nhập số tiền..."
                              :arrayParent="returnFreeArr"
                              :FeeKey="returnFreeKey"
                              valueKey="value"
                              :max="getTotalPrice"
                              @change="checkToDeleteAllReturn('phí')"
                              @changeFeeKey="returnFreeKey = $event"
                            ></InputMoneyHaveFee>
                          </div>
                        </div>
                      </el-popover>
                    </div>
                    <div class="col-md-6">{{ formatMoneyNotUnit(getReturnFee) }} đ</div>
                  </div>
                </div>
              </div>
              <div class="bottom-border w-50 ml-auto"></div>
              <div class="row py-1">
                <div class="col-md-6"></div>
                <div class="col-md-6 text-right">
                  <div class="row">
                    <div class="col-md-6">Tổng tiền hàng trả</div>
                    <div class="col-md-6">
                      <!-- <b>{{ formatMoneyNotUnit(getTotalPriceAddFee) }} đ</b> -->
                      <b>{{ formatMoneyNotUnit(getTotalPrice + getReturnFee) }} đ</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Hoàn tiền cho khách -->
          <div class="__card__order-return mt-3" v-if="!isReturnHasExchange">
            <h1 class="__card__order-return_title">Hoàn tiền cho khách</h1>
            <div class="row mt-3 w-100">
              <div class="col-md-2">Tổng phải hoàn</div>
              <div class="col-md-3 px-2">
                <b>{{ refundPolicy ? formatMoneyNotUnit(getTotalPriceAddFee) : 0 }} đ</b>
              </div>
              <!-- <div v-if="refundPolicy" class="col-md-6">
              <div class="row">
                <div class="col-md-4">Số tiền còn lại</div>
                <div class="col-md-4">
                  <b class="text-primary cursor" @click="outComeAmount = getPriceWillPay">{{ formatMoneyNotUnit(getPriceWillPay) }} đ</b>
                </div>
              </div>
            </div> -->
            </div>
            <div v-if="refundPolicy" class="row mt-3 w-100">
              <div class="col-md-2 mt-2">Thêm số tiền hoàn</div>
              <div class="col-md-3 px-2">
                <el-select v-model="payMethod" class="m-2 el pay-method">
                  <el-option v-for="item in payMethodList" :key="item.id" :label="item.text" :value="item.value"> </el-option>
                </el-select>
              </div>
              <div class="col-md-3 px-2">
                <InputMoneyVmodel
                  placeholder="Nhập số tiền..."
                  v-model="outComeAmount"
                  :max="getPriceWillPay"
                  class="form-control"
                >
                </InputMoneyVmodel>
              </div>
              <div class="col-md-3 px-2">
                <input placeholder="Thêm mã tham chiếu" type="text" class="form-control" v-model="gatewayTransactionId" />
              </div>
              <div class="col-md-1 px-2">
                <button
                  class="btn btn-fix-sỉze btn-nomarl text-primary cusor"
                  type="primary"
                  plain
                  :disabled="!isAddButtonShow"
                  @click="addOutComeAmount"
                >
                  Thêm
                </button>
              </div>
            </div>
            <div v-if="!refundPolicy" class="row w-100 d-flex justify-content-center my-3">
              <div class="col-10">
                <b-alert class="custom-alert m-0" show variant="warning text-dark">
                  Giá trị cần hoàn trả bằng 0 do cửa hàng đã bật cấu hình <b>“Không hoàn tiền khi đổi trả hàng”</b>.<br />
                  Để cài đặt lại, vui lòng đi tới
                  <b><router-link :to="{ path: '/setting/config' }">Cấu hình bán hàng</router-link></b>
                </b-alert>
              </div>
            </div>
            <div class="w-100">
              <b-table tbody-tr-class="repay-table" :items="rePay" :fields="fieldsRePay" :key="updateUI" show-empty>
                <template #empty>
                  <EmptyTable content="Chưa có thanh toán nào" noImage></EmptyTable>
                </template>
                <template #cell(requestAt)="data">
                  {{ data.item.params.requestAt | formatDateTime }}
                </template>
                <template #cell(employeeName)="data">
                  {{ data.item.params.employeeName }}
                </template>
                <template #cell(payMethod)="data">
                  {{ allPayment[data.item.params.payMethod].name }}
                </template>
                <template #cell(amount)="data">
                  {{ formatMoneyNotUnit(data.item.params.amount) }}
                </template>
                <template #cell(gatewayTransactionId)="data">
                  {{ data.item.params.gatewayTransactionId }}
                </template>
                <template #cell(edit)="data">
                  <span @click="deleteItem(data.index)"><img class="delete-icon" src="@/assets/images/delete-vector.png"/></span>
                </template>
              </b-table>
            </div>
            <div class="mt-3 w-100">
              <PayDetail>
                <template #title>Tổng phải hoàn</template>
                <template #price
                  ><b>{{ formatMoneyNotUnit(getTotalPriceAddFee) }} đ</b></template
                >
              </PayDetail>
              <PayDetail>
                <template #title>Đã thanh toán</template>
                <template #price>{{ formatMoneyNotUnit(getPricePayed) }} đ</template>
              </PayDetail>
              <div class="ml-auto col-6 bottom-border"></div>
              <PayDetail>
                <template #title>Còn lại</template>
                <template #price
                  ><b>{{ formatMoneyNotUnit(getPriceWillPay) }} đ</b></template
                >
              </PayDetail>
            </div>
          </div>
        </template>

        <!-- <ProductExchange v-show="statusActive == 1"></ProductExchange> -->
        <ProductExchangeV2 :datas="datas" v-show="statusActive == 1"></ProductExchangeV2>
        <div v-show="statusActive == 2">
          <HandleCustomerPayment
            @createOrder="createOrderHasExchange"
            v-show="getReturnPrice < getExchangePrice"
            :dataItem="dataItem"
            :rePay="rePay"
            :updateOrderId="updateOrderId"
            :createOrderData="createOrderData"
            @deleteRepayItem="deleteItem"
            @addRepayItem="addOutComeAmount"
          ></HandleCustomerPayment>
            <!-- @updateRePay="($event) => (rePay = $event)" -->
          <HandleStorePayment
            :refundPolicy="refundPolicy"
            @deleteRepayItem="deleteItem"
            @addRepayItem="addOutComeAmount"
            :rePay="rePay"
            v-show="getReturnPrice >= getExchangePrice"
            :dataItem="dataItem"
          ></HandleStorePayment>
        </div>
      </div>

      <el-dialog
        append-to-body
        title="Chọn lô HSD"
        width="700px"
        :visible.sync="openDataUseProductBatch"
        class="boxInfoProductBatch"
        v-if="openDataUseProductBatch"
      >
        <div class="content-item-pos-change">
          <div>
            <input type="text" class="input w-100" placeholder="Tìm kiếm mã lô" v-model="keySearch" @keyup="changeKeySearch" />
          </div>
          <div class="mt-2 scrolTable">
            <table class="w-100">
              <thead>
                <tr>
                  <th style="width:25%">Mã lô</th>
                  <th style="width:15%">Hạn sử dụng</th>
                  <th style="width:20%" class="text-center">Số lượng</th>
                  <th style="width:15%" class="text-center">Số lượng trả</th>
                </tr>
              </thead>
              <tbody v-if="dataBatchItemSearch.length > 0">
                <tr v-for="(item, index) in dataBatchItemSearch" :key="index">
                  <td>
                    <input
                      type="text"
                      class="input w-90 disabled"
                      placeholder="Tìm kiếm mã lô"
                      disabled
                      :value="item.batchCode"
                    />
                  </td>

                  <td :class="item.isExpiration ? 'text-red' : 'text-black'">
                    {{ convertDateItem(item.expirationDate) }}
                    <div v-if="item.isExpiration" class="fz-12">
                      <i>Đã hết hạn</i>
                    </div>
                  </td>

                  <td class="text-center">{{ item.quantity }}</td>

                  <td class="text-center" v-if="item.isExpiration && !checkExpirationDate">
                    <span class="num"><i class="el-icon-minus"></i></span>
                    <input type="text" class="input w-50 text-center disabled" value="0" min="0" disabled />
                    <span class="num"><i class="el-icon-plus"></i></span>
                  </td>
                  <td class="text-center" v-else>
                    <span class="num" @click="clickPlusBatch(item, 'minus')"><i class="el-icon-minus"></i></span>
                    <input
                      v-if="item.quantity > 0"
                      type="text"
                      class="input w-50 text-center"
                      v-model="item.quantityVal"
                      min="0"
                      @keydown.enter.prevent
                      @keydown="allowNumbersOnly"
                      @change="checkNumbersBatch(item)"
                      @keyup="checkNumbersBatch(item)"
                    />
                    <input type="text" class="input w-50 text-center disabled" value="0" min="0" disabled v-else />
                    <span class="num" @click="clickPlusBatch(item, 'plus')"><i class="el-icon-plus"></i></span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-black-500 text-center bd-td-head" colspan="4">Không có tìm thấy lô của sản phẩm</td>
                </tr>
              </tbody>
            </table>
            <div class="byExp" v-if="!checkExpirationDate && checkIndexExpiration">
              Để bán được sản phẩm đã hết hạn sử dụng, vui lòng đi tới
              <a target="_blank" href="/setting/config">Cấu hình bán hàng <i class="fa fa-chevron-right fz-12"></i></a>
            </div>
          </div>
          <div class="mt-3 w-100 text-right bdTopBottom">
            <button class="btn btn-default text-primary" @click="openDataUseProductBatch = false">Thoát</button>
            <button class="btn btn-primary" @click="saveDataUseProductBatch">Hoàn tất</button>
          </div>
        </div>
      </el-dialog>

      <!-- popupAddCustomer -->
      <PopupAddCustomer :listCustomer="listCustomer" :show="showModalAddCustomerNew" @addCustomerDone="addCustomerDone" @close="showModalAddCustomerNew = false" />

        <!--Popup: them lo vao don hang-->
      <b-modal v-model="modalAddAutoSelectBatch" hide-footer centered no-close-on-backdrop id="modalAddAutoSelectBatch">
        <template #modal-header>
          <h1 class="fz-18 mb-0"><b>Thêm lô vào đơn hàng</b></h1>
          <button type="button" aria-label="Close" class="close close-ext pb-0 pt-3"
            @click="modalAddAutoSelectBatch = false">×</button>
        </template>
        <div class="line">
          <div class="introBatch mt-2">
            Sản phẩm trong đơn hàng cần được thêm lô. Hệ thống sẽ tự động lấy ra lô có ngày hết hạn gần nhất để điền vào
            đơn hàng.
          </div>
          <div class="contentBatch mt-3">
            <table class="w-100">
              <thead>
                <tr>
                  <th width="40%">Tên sản phẩm</th>
                  <th width="20%">Mã lô</th>
                  <th width="15%">Hạn sử dụng</th>
                  <th width="10%" class="text-center">SL thêm</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(batch, index) in showGenAutoSelectBatch" :key="index">
                  <td>{{ batch.itemName }}</td>
                  <td>{{ batch.batchCode }}</td>
                  <td>{{ convertDateItem(batch.expirationDate) }}</td>
                  <td class="text-center">{{ batch.quantity }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="line mt-3">
            <button type="button" class="btn btn-primary pull-right" @click="clickConfirmAddAutoSelectBatch">Xác nhận</button>
            <button type="button" class="btn btn-default text-primary pull-right"
              @click="modalAddAutoSelectBatch = false">Sửa đơn hàng</button>
          </div>
        </div>
      </b-modal>

    </div>
    <NotPermission v-else></NotPermission>
    <div class="box-loading" v-if="loading">
      <div class="loading">
        <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { getStorageItem } from "@/utils/auth";
import Head from "./components/head.vue";
import { OrdersService } from "@/services/nextshop/orders.service";
// import { LocationService } from "@/services/nextshop/location.service";
import { formatMoney, allPayment } from "@/utils/mapping";
import moment from "moment";
import { SettingService } from "@/services/nextshop/setting.service";
import Select2MultipleControl from "v-select2-multiple-component";
import _ from "lodash";
import { CustomerServices } from "@/services/nextshop/customer.service";
import PopupAddCustomer from "./components/popupAddCustomer.vue";
import InputMoneyHaveFee from "./components/inputMoneyHaveFee.vue";
import InputMoneyVmodel from "./components/inputMoneyVmodel.vue";
import ProductExchangeV2 from "./components/productExchangev2.vue";
import PayDetail from "./components/payDetail.vue";
import HandleCustomerPayment from "./components/handleCustomerPayment.vue";
import HandleStorePayment from "./components/handleStorePayment.vue";
import { mapGetters, mapMutations } from "vuex";
import { getNewDefaultPos, showMess  } from "../V2/pos/utils/pos";
import getParamSell from "../V2/pos/mixins/pos"


export default {
  name: "orders-return-create",
  components: {
    Head,
    Select2MultipleControl,
    PopupAddCustomer,
    InputMoneyHaveFee,
    InputMoneyVmodel,
    ProductExchangeV2,
    PayDetail,
    HandleCustomerPayment,
    HandleStorePayment,
  },
  mixins: [getParamSell],

  data() {
    return {
      modalAddAutoSelectBatch: false,
      showGenAutoSelectBatch: [],

      datas: {
        orders: [getNewDefaultPos()],
        paymentChoose: [],
        enableInventory: false,
        activeNegativeInv: false,
      },
      allPayment: allPayment,
      dataPermission: getStorageItem("dataPermission"),
      inforAccount: getStorageItem("auth.currentUser"),
      loading: false,
      updateUI: 1,
      products: [],
      reasonReturnList: [
        {
          id: 1,
          text: "Hàng hỏng",
        },
        {
          id: 2,
          text: "Thu hồi hàng lỗi",
        },
        {
          id: 3,
          text: "Khách muốn đổi trả",
        },
        {
          id: 4,
          text: "Hàng hết hạn",
        },
        {
          id: 5,
          text: "Khác",
        },
      ],
      search: "",
      fields: [
        {
          key: "stt",
          label: "#",
          thStyle: { width: "5%", "min-width": "50px" },
        },
        {
          key: "sku",
          label: "Mã SKU",
          thStyle: { width: "15%", "min-width": "170px" },
        },
        {
          key: "itemName",
          label: "Phiên bản sản phẩm",
          thStyle: {
            width: "35%",
            "min-width": "120px",
            "word-break": "break-word",
          },
        },
        {
          key: "quantityVal",
          label: "Số lượng",
          thStyle: { width: "15%", "min-width": "120px" },
        },
        {
          key: "price",
          label: "Giá hàng trả",
          thStyle: { width: "18%", "min-width": "120px" },
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "total",
          label: "Thành tiền",
          thStyle: { width: "15%", "min-width": "120px" },
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      rePay: [],
      payMethod: "CASH_NEXT_SHOP",
      payMethodList: [
        {
          id: 1,
          text: "Tiền mặt",
          value: "CASH_NEXT_SHOP",
        },
        {
          id: 2,
          text: "Chuyển khoản",
          value: "BANK_TRANSFER_NEXT_SHOP",
        },
      ],

      fieldsRePay: [
        {
          key: "requestAt",
          label: "Thời gian",
          thStyle: { width: "20%", "min-width": "120px" },
        },
        {
          key: "employeeName",
          label: "Người thực hiện",
          thStyle: {
            width: "20%",
            "min-width": "120px",
            "word-break": "break-word",
          },
        },
        {
          key: "payMethod",
          label: "Phương thức",
          thStyle: { width: "20%", "min-width": "120px" },
        },
        {
          key: "amount",
          label: "Số tiền hoàn",
          thStyle: { width: "20%", "min-width": "120px" },
        },
        {
          key: "gatewayTransactionId",
          label: "Mã tham chiếu",
          thStyle: { width: "20%", "min-width": "120px" },
        },
        {
          key: "edit",
          label: "",
          thStyle: { width: "5%", "min-width": "50px" },
        },
      ],
      totalPrice: 0,
      returnFree: 0,
      returnFreeKey: "đ",
      returnFreeArr: [
        {
          isMoney: true,
          key: "đ",
          value: 0,
        },
        {
          isMoney: false,
          key: "%",
          value: 0,
        },
      ],
      branch: "",
      dataItem: {},
      outComeAmount: 0,
      gatewayTransactionId: "",
      returnReasonOther: "",
      returnOrderParams: {
        customerId: "",
        customerName: "",
        note: "",
        referenceCode: "",
        returnReason: "Khách muốn đổi trả",
      },
      isReceivedItem: false,
      refundPolicy: true,

      openDataUseProductBatch: false,
      dataBatchItem: [],
      dataBatchItemChoose: [],
      keySearch: "",
      dataBatchItemSearch: [],
      lineItemSelect: [],
      indexLineItemSelect: "",
      checkExpirationDate: false,
      checkIndexExpiration: false,

      productsSearchData: [],

      showQuickHandle: false,

      nowTime: moment(new Date()).format("DD/MM/YYYY"),

      // add customer
      showModalAddCustomerNew: false,
      coMerchantId: JSON.parse(localStorage.getItem("auth.currentMerchant")).id,
      listCustomer: [],
      customer: {
        resId: "",
        displayName: "Khach vãng lai",
        text: "Khach vãng lai",
      },

      // trả hàng có đổi hàng
      isReturnHasExchange: false,
      statusOrder: [
        {
          title: "Tạo đơn trả",
          description: "",
        },
        {
          title: "Chọn sản phẩm đổi ",
          description: "",
        },
        {
          title: "Thanh toán",
          description: "",
        },
      ],
      statusActive: 0,
      test: "",
      paramTemp: {},
      updateOrderId: "",
      createOrderData: {},
    };
  },

  async created() {
    // await this.clearCache();
    await Promise.all([this.getItemSO(), this.getMainApiMerchantReturn(), this.searchProduct(), this.fetchListCustomer()]);
    this.getCustomer();
  },

  methods: {
    ...mapMutations("ordersReturn", ["setReturnPrice", "setExchangePrice", "setIsPayWithMpos"]),
    // ...mapMutations("pos", ["SET_INFOR_POS", "SET_ID_POS"]),
    // clearCache() {
    //   this.SET_INFOR_POS({ ...defaultPos });
    //   this.SET_ID_POS(0);
    // },
    findCustomer(id) {
      const newCustomer = this.listCustomer.find((e) => e.id === id || e.coPartnerId === id);
      return newCustomer;
    },
    getCustomer() {
      const customerId = this.dataItem.partyB.resId ? this.dataItem.partyB.resId : "";
      if (customerId) {
        const result = this.findCustomer(customerId);
        if (result) {
          this.customer.resId = result.id;
        }
      }
    },
    async fetchListCustomer() {
      try {
        const data = await CustomerServices.getListCustomer({
          query: "",
          merchantId: this.coMerchantId,
          person: 2,
          sort: "date",
        });
        if (data.success) {
          this.listCustomer = data.data.map((e) => {
            return {
              ...e,
              text: e.name + " - " + e.phoneNo,
            };
          });
        }
      } catch (error) {
        console.log(error);
      }
      this.listCustomer.unshift({
        resId: "",
        name: "khách vãng lai",
        phoneNo: "---",
        text: "khách vãng lai",
      });
    },
    async getMainApiMerchantReturn() {
      try {
        const response = await SettingService.mainApiMerchant();
        if (response.success) {
          this.refundPolicy = response.data.refundPolicy === "REFUND" ? true : false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    addCustomerDone(param) {
      if (param) {
        this.listCustomer.push(param);
        this.customer.resId = param.id;
        this.customer.displayName = param.displayName;
      }
      this.showModalAddCustomerNew = false;
    },

    formatMoney(val) {
      const result = formatMoney(val);
      return result;
    },
    SODetail() {
      const itemId = this.$route.params.id;
      this.$router.push({ path: `/pos/pos-detail/${itemId}` });
    },
    async getItemSO() {
      const itemId = this.$route.params.id;
      if (itemId != "") {
        this.loading = true;
        try {
          let response = await OrdersService.getOrderById(itemId);
          this.branch = response.data.locationToCreate;
          if (response.success && response.data.id != "") {
            // this.returnOrderParams.customerName = response.data.partyB.displayName
            response.data = this.outputOrdersData(response.data);
            const productsRaw = response.data.lineItem;
            response.data.lineItem = this.mergeLineItemLoHsd(response.data.lineItem);

            const dataItemRaw = response.data;
            // this.returnOrderParams.referenceCode = response.data.orderReferenceId ? response.data.orderReferenceId : "";

            if (dataItemRaw.lineItem.length > 0) {
              const DISCOUNT_ALL_OBJ = dataItemRaw.lineItemFinalizing.addedFee.find((e) => e.cat === "DISCOUNT_ALL");
              const DISCOUNT_ALL = DISCOUNT_ALL_OBJ ? DISCOUNT_ALL_OBJ.amount : 0;
              const netSubTotal = dataItemRaw.lineItemFinalizing.netSubTotal ? dataItemRaw.lineItemFinalizing.netSubTotal : 0;
              const TAX_ALL_OBJ = dataItemRaw.lineItemFinalizing.addedFee.find((e) => e.cat === "TAX_ALL");
              const TAX_ALL = TAX_ALL_OBJ ? TAX_ALL_OBJ.amount : 0;

              let CK = Math.abs((DISCOUNT_ALL ? DISCOUNT_ALL : 0) / (netSubTotal != 0 ? netSubTotal : 1));
              const totalTax = TAX_ALL ? TAX_ALL : 0;

              let VAT = (totalTax / (netSubTotal + DISCOUNT_ALL)) * 100;

              dataItemRaw.lineItem.map((item) => {
                let TT = item.totalAmount / item.quantity;
                let returnAble;
                item.useImeiAndSerial = false;
                item.useProductBatch = false;
                item.getSeri = [];

                // seriesNo
                if (item.lineItemOtherInfo.seriesNo && item.lineItemOtherInfo.seriesNo.length > 0) {
                  item.useImeiAndSerial = true;
                  if (item.lineItemOtherInfo.returnable && item.lineItemOtherInfo.returnable == "0.0") {
                    item.getSeri = [];
                  } else if (item.lineItemOtherInfo.returnableSerial && item.lineItemOtherInfo.returnableSerial != null) {
                    if (typeof item.lineItemOtherInfo.returnableSerial == "string")
                      item.lineItemOtherInfo.returnableSerial = JSON.parse(item.lineItemOtherInfo.returnableSerial);
                    item.lineItemOtherInfo.returnableSerial.map((e) => {
                      item.getSeri.push({ id: e, text: e });
                    });
                  } else {
                    item.lineItemOtherInfo.seriesNo.map((e) => {
                      item.getSeri.push({ id: e, text: e });
                    });
                  }

                  returnAble = item.lineItemOtherInfo.returnable ? +item.lineItemOtherInfo.returnable : item.quantity;
                  item.quantityVal = 0;
                  item.quantity = returnAble;
                  item.totalVal = item.quantityVal * item.unitPrice;
                }

                // productBatch
                item.batchTmp = [];
                if (item.lineItemOtherInfo.productBatch && item.lineItemOtherInfo.productBatch != null) {
                  item.useProductBatch = true;

                  item.lineItemOtherInfo.arrProductBatch.forEach((e) => {
                    for (let i = 0; i < productsRaw.length; i++) {
                      const raw = productsRaw[i];
                      if (raw.lineItemOtherInfo.BATCH_CODE && raw.lineItemOtherInfo.BATCH_CODE === e.batchCode) {
                        e.returnable = raw.lineItemOtherInfo.returnable;
                        if (e.returnable) {
                          e.returnable = +e.returnable;
                          e.quantity = e.returnable;
                        }
                        break;
                      }
                    }
                    // console.log({e})
                  });
                  // console.log(333, item.lineItemOtherInfo.arrProductBatch)
                  item.quantityVal = 0;

                  let totalQuantity = 0;
                  item.lineItemOtherInfo.arrProductBatch.map((item) => {
                    totalQuantity += item.quantity;
                  });
                  item.quantity = totalQuantity;

                  item.totalVal = item.quantityVal * item.unitPrice;
                }

                // normal
                // console.log(345, item)
                if (!item.lineItemOtherInfo.productBatch && item.lineItemOtherInfo.seriesNo.length == 0) {
                  returnAble = item.lineItemOtherInfo.returnable ? +item.lineItemOtherInfo.returnable : item.quantity;

                  item.quantityVal = 0;
                  item.quantity = returnAble;
                  item.totalVal = item.quantityVal * item.unitPrice;
                }

                // tinh gía trả
                // console.log({TT, CK , VAT})
                // TT - TT * CK + VAT
                const returnProductPrice = Math.floor((TT - TT * CK) * (1 + VAT / 100))
                  ? Math.floor((TT - TT * CK) * (1 + VAT / 100))
                  : 0;
                item.returnProductPrice = returnProductPrice;
                item.returnProductPriceMax = returnProductPrice;
                item.returnProductPriceAddFree = returnProductPrice;
                // fee product
                (item.productFreeKey = "đ"),
                  (item.productFreeArr = [
                    {
                      isMoney: true,
                      key: "đ",
                      value: 0,
                    },
                    {
                      isMoney: false,
                      key: "%",
                      value: 0,
                    },
                  ]),
                  this.products.push({ ...item });
              });
            }
            // console.log(444, this.products)
            this.dataItem = dataItemRaw;

            // const locationToCreate = dataItemRaw.locationToCreate;
            // if (locationToCreate != "") {
            //   this.getDataLocation(locationToCreate);
            // }
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      } else {
        this.$router.push({ path: `/orders` });
      }
    },
    // async getDataLocation(locationId) {
    //   try {
    //     if (locationId !== "") {
    //       const response = await LocationService.getDetailLocation({
    //         locationId: locationId,
    //       });
    //       if (response.success) {
    //         this.dataLocation = response.data;
    //       }
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    async loadDataUseProductBatch(index, item) {
      this.openDataUseProductBatch = true;
      //Array Default
      this.dataBatchItem =
        item.lineItemOtherInfo.arrProductBatch && item.lineItemOtherInfo.arrProductBatch.length > 0
          ? item.lineItemOtherInfo.arrProductBatch
          : [];
      this.changeKeySearch(index, item);
    },

    changeKeySearch(index, item) {
      this.dataBatchItemSearch = [];
      this.dataBatchItemChoose = [];
      this.lineItemSelect = item;
      this.indexLineItemSelect = index;

      //Search
      const keySearch = this.keySearch.toLowerCase().trim();
      if (keySearch != "") {
        this.dataBatchItemSearch = [];
        return this.dataBatchItem.filter((item) => {
          const batchCode = item.batchCode.toLowerCase().trim();
          if (batchCode != "") {
            if (batchCode.includes(keySearch)) {
              this.dataBatchItemSearch.push(item);
            }
          }
        });
      } else {
        this.dataBatchItemSearch = this.dataBatchItem;
      }

      const indexLineItem = this.indexLineItemSelect;

      this.dataBatchItemSearch.map((item, index) => {
        if (this.products[indexLineItem].batchTmp.length > 0) {
          const indexVal = this.products[indexLineItem].batchTmp.findIndex((e) => e.batchCode == item.batchCode);
          if (indexVal != -1) {
            this.dataBatchItemSearch[index].quantityVal = this.products[indexLineItem].batchTmp[indexVal].quantityVal;
            this.dataBatchItemChoose.push(this.dataBatchItemSearch[index]);
          }
        } else {
          this.dataBatchItemSearch.map((e) => {
            e.quantityVal = 0;
          });
        }
      });
    },

    saveDataUseProductBatch() {
      if (this.dataBatchItemChoose.length > 0) {
        this.products[this.indexLineItemSelect].batchTmp = [];
        let runTotal = 0;
        this.dataBatchItemChoose.map((item) => {
          if (item.quantityVal > 0) {
            this.products[this.indexLineItemSelect].batchTmp.push(item);
            runTotal += item.quantityVal;
          }
        });
        this.products[this.indexLineItemSelect].quantityVal = runTotal;
      } else {
        this.products[this.indexLineItemSelect].quantityVal = 0;
      }
      this.openDataUseProductBatch = false;
    },

    removeItemUseProductBatch(indexBatch, itemBatch, indexLineItem) {
      this.products[indexLineItem].batchTmp.splice(indexBatch, 1);
      const indexVal = this.dataBatchItemSearch.findIndex((e) => e.batchCode == itemBatch.batchCode);
      if (indexVal != -1) {
        this.dataBatchItemSearch[indexVal].quantityVal = 0;
      }
      let totalQuantityVal = 0;
      this.products[indexLineItem].batchTmp.map((item) => {
        totalQuantityVal += item.quantityVal;
      });
      this.products[indexLineItem].lineItemOtherInfo.arrProductBatch[indexBatch].quantityVal = 0;
      this.products[indexLineItem].quantityVal = totalQuantityVal;
    },

    clickPlusBatch(item, type) {
      if (type == "minus") {
        item.quantityVal--;
        item.quantityVal = item.quantityVal < 0 ? 0 : parseInt(item.quantityVal);
      }
      if (type == "plus") {
        item.quantityVal++;
        item.quantityVal = item.quantityVal > item.quantity ? parseInt(item.quantity) : item.quantityVal;
      }
      this.checkNumbersBatch(item);
    },

    checkNumbersBatch(item) {
      if (isNaN(item.quantityVal) || item.quantityVal === undefined || item.quantityVal == "") {
        item.quantityVal = 0;
        return false;
      }
      item.quantityVal = item.quantityVal > item.quantity ? parseInt(item.quantity) : parseInt(item.quantityVal);
      if (this.dataBatchItemChoose.length > 0) {
        const indexVal = this.dataBatchItemChoose.findIndex((e) => e.batchCode == item.batchCode);
        if (indexVal != -1) {
          if (item.quantityVal > 0) {
            this.dataBatchItemChoose[indexVal].quantityVal = parseInt(item.quantityVal);
          } else {
            this.dataBatchItemChoose.splice(indexVal, 1);
          }
        } else {
          if (item.quantityVal > 0) {
            this.dataBatchItemChoose.push(item);
          }
        }
      } else {
        if (item.quantityVal > 0) {
          this.dataBatchItemChoose.push(item);
        }
      }
    },

    async removeTextSearch() {
      this.search = "";
      this.searchProduct();
    },

    checkNumber(item) {
      if (item.quantityVal > item.quantity) {
        item.quantityVal = item.quantity;
      }
    },

    getProductPriceAddFree(item) {
      const { quantityVal, returnProductPrice, productFreeKey, productFreeArr } = item;
      if (productFreeKey == "đ") {
        item.returnProductPriceAddFree = returnProductPrice - productFreeArr[0].value;
      }

      if (productFreeKey == "%") {
        item.returnProductPriceAddFree = returnProductPrice - Math.floor((productFreeArr[1].value / 100) * returnProductPrice);
      }
      return Math.floor(quantityVal * item.returnProductPriceAddFree);
    },

    getProductFreeValue(item) {
      const { returnProductPrice, productFreeKey, productFreeArr } = item;
      if (productFreeKey == "đ") {
        return productFreeArr[0].value;
      }

      if (productFreeKey == "%") {
        return Math.floor((productFreeArr[1].value / 100) * returnProductPrice);
      }
      return 0;
    },

    checkToDeleteAllReturn(name) {
      if (this.rePay.length != 0) {
        Swal.fire({
          title: "Cảnh báo!",
          text: `Việc sửa ${name} sẽ xóa toàn bộ các thao tác hoàn tiền.`,
          icon: "warning",
          confirmButtonText: "Xác nhận",
        });
        this.rePay = [];
      }
    },
    searchProductDebounce: _.debounce(function() {
      this.searchProduct();
    }, 300),

    searchProduct() {
      const searchText = this.search.trim().toLowerCase();
      if (searchText == "") {
        this.productsSearchData = this.products;
      } else {
        this.productsSearchData = this.products.filter((product) => {
          return (
            product.itemInstance.moreInformation.sku.toLowerCase().includes(searchText) ||
            product.itemInstance.name.toLowerCase().includes(searchText)
          );
        });
      }
    },

    // getPayMethod(method) {
    //   if (method == "BANK_TRANSFER") {
    //     return "Chuyển Khoản";
    //   } else if (method == "CASH") {
    //     return "Tiền mặt";
    //   } else {
    //     return "";
    //   }
    // },

    addOutComeAmount(itemTemp) {
      let item = {
        params: {
          payMethod: this.payMethod,
          amount: this.outComeAmount,
          employeeName: this.dataItem.partyA.displayName,
          requestAt: moment(),
          gatewayTransactionId: this.gatewayTransactionId,
        },
      };
      if (itemTemp) {
        item = { ...item, ...itemTemp };
      }
      this.rePay.push(item);
      this.outComeAmount = this.getPriceWillPay;
      this.gatewayTransactionId = ""
    },

    deleteItem(index) {
      this.rePay.splice(index, 1);
      this.outComeAmount = this.getPriceWillPay;
      // them vao day
    },

    handleSelectAll() {
      this.products.forEach((e) => {
        // console.log({e})
        if (e.useProductBatch) {
          // console.log(33, e.lineItemOtherInfo.arrProductBatch)
          e.lineItemOtherInfo.arrProductBatch.forEach((item) => {
            item.quantityVal = item.quantity;
          });
          e.batchTmp = e.lineItemOtherInfo.arrProductBatch.filter((item) => item.quantity > 0);
        }
        if (e.useImeiAndSerial) {
          e.seriesNoTmp = [];
          e.getSeri.map((item) => {
            e.seriesNoTmp.push(item.text);
          });
        }

        e.quantityVal = e.quantity;
      });

      this.showQuickHandle = false;
      this.checkToDeleteAllReturn("số lượng");
    },
    handleSelectNo() {
      this.products.forEach((e) => {
        if (e.useProductBatch) {
          e.lineItemOtherInfo.arrProductBatch.forEach((item) => {
            item.quantityVal = 0;
          });
          e.batchTmp = [];
        }
        if (e.useImeiAndSerial) {
          e.seriesNoTmp = [];
        }
        e.quantityVal = 0;
      });
      this.showQuickHandle = false;
      this.checkToDeleteAllReturn("số lượng");
    },
    isHaveQuantity() {
      let check = false;
      this.products.map((e) => {
        if (e.quantityVal > 0) check = true;
      });
      return check;
    },

    checkHasQuantity() {
      if (!this.isHaveQuantity()) {
        Swal.fire({
          title: "Cảnh báo!",
          text: `Bạn chưa chọn sản phẩm nào.`,
          icon: "warning",
          confirmButtonText: "Xác nhận",
        });
        return false;
      }
      return true;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    async clickConfirmAddAutoSelectBatch() {
      await this.addShowGenAutoSelectBatch(this.showGenAutoSelectBatch, this.itemPos)
      this.modalAddAutoSelectBatch = false
    },
    async pushAutoSelectBatch() {
      const inventoryId = localStorage.getItem("inventoryID")
      const listItemCarts = this.itemPos.listItemCart
      const autoSelectBatch = await this.getProductBatchAutoSelectBatch(inventoryId, listItemCarts)
      if (autoSelectBatch.checkBatch) {
        if (autoSelectBatch.itemBatch.length > 0) {
          this.showGenAutoSelectBatch = await this.genAutoSelectBatch(autoSelectBatch.itemBatch)
          this.modalAddAutoSelectBatch = true
          return false
        }
      }
      return true
    },

    async continueReturn() {
      if (this.statusActive == 1) {
        if(this.checkIsEmptyCart()) {
          this.showSwal("Giỏ hàng chưa có sản phẩm nào! Vui lòng chọn sp đổi.")
          return
        }
        const checkLess = this.checkLessAutoSelectBatch(this.itemPos.listItemCart)
        if (!checkLess) {
            showMess(this, 'Thông báo', 'Tổng số lượng trong Lô/Hsd đang lớn hơn số lượng bán!', 'danger', 'b-toaster-top-right', 1000)
            return false
        }

        const checkLessSeri = this.checkLessSeriSelect(this.itemPos.listItemCart)
        if (!checkLessSeri) {
            showMess(this, 'Thông báo', 'Vui lòng chọn thêm Seri vào đơn!', 'danger', 'b-toaster-top-right', 1000)
            return false
        }
        
        const check = await this.pushAutoSelectBatch()
        if (!check) { return false }
      }
      if (!this.checkHasQuantity()) return;
      this.scrollToTop();
      this.statusActive++;
    },

    checkIsEmptyCart() {
      const POS = this.datas.orders[0]
      if(POS && POS.listItemCart.length) {
        return false
      } else {
        return true
      }
    },
    showSwal(message) {
      Swal.fire({
          title: "Cảnh báo!",
          text: message,
          icon: "warning",
          confirmButtonText: "Xác nhận",
        });
    },
    async createOrderHasExchange() {
      if (this.checkIsEmptyCart()) {
        this.showSwal("Giỏ hàng chưa có sản phẩm nào! Vui lòng chọn sp đổi.")
        this.statusActive--
        return
      }
      console.log("create");
      const params = this.getParams();
      const paramPos = this.getParamSell(_.cloneDeep(this.itemPos))
      const paramsLast = this.inputOrdersData(paramPos);
      // console.log(333231, {params, paramPos ,paramsLast});
      // return
      const exchangeOrder = {
        targetMethod: "NEXT_SHOP_POS_WEB_ENABLE_DRAFT",
        lineItem: paramsLast.lineItem,
        addFees: paramsLast.addFees,
      };

      params.exchangeOrder = exchangeOrder;
      try {
        // console.log(333, params);
        // return;
        const response = await OrdersService.createReturnHasExchange(params);
        if (response.success) {
          this.updateOrderId = response.data.id;
          this.createOrderData = response.data;
          // this.setIsPayWithMpos(true)
          if (this.getIsPayWithMpos) {
            this.paramTemp = params;
            return;
          }
          this.$router.push({ path: `/orders-return/detail/${this.updateOrderId}` });
        } else {
          Swal.fire({
            title: "Error",
            text: response.message,
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async updateOrderHasExchange() {
      console.log("update");
      // do some thing
      console.log(this.paramTemp);
      let params = _.cloneDeep(this.paramTemp);
      delete params["soOrderId"];
      params.orderId = this.updateOrderId;

      const temp = {
        orderId: this.updateOrderId,
        paymentList: this.getPaymentList(),
      };
      params = { ...params, ...temp };

      try {
        this.loading = true;
        const response = await OrdersService.updateExchangeReturnOrder(params);
        if (response.success) {
          this.$router.push({ path: `/orders-return/detail/${this.updateOrderId}` });
        } else {
          Swal.fire({
            title: "Error",
            text: response.message,
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async confirmReturn() {
      // console.log(1);
      if (!this.checkHasQuantity()) return;
      if (this.getIsPayWithMpos) {
        // update
        this.$router.push({ path: `/orders-return/detail/${this.updateOrderId}` });
        // this.updateOrderHasExchange()
      } else {
        // create
        this.createOrderHasExchange();
      }
    },

    getPaymentList() {
      const paymentList = [];
      this.rePay.map((e) => {
        const { amount, payMethod, gatewayTransactionId } = e.params;
        const temp = {
          amount: this.multiplicationThousand(amount),
          isNew: true,
          paymentGateway: allPayment[payMethod].paymentGateway,
          paymentMethod: allPayment[payMethod].paymentMethod,
          status: "SUCCESS",
          gatewayTransactionId: gatewayTransactionId,
        };
        paymentList.push(temp);
      });
      return paymentList;
    },

    getParams() {
      const paymentList = this.getPaymentList();
      let returnedLineItem = [];

      this.products.map((e) => {
        if (e.quantityVal && e.quantityVal > 0) {
          let lineItemOtherInfo = {};

          if (e.seriesNoTmp && e.seriesNoTmp.length > 0) {
            lineItemOtherInfo.seriesNo = e.seriesNoTmp;
          }
          let temp;
          temp = {
            quantity: +e.quantityVal,
            unitPrice: +e.returnProductPrice * 1000,
            amount: +e.returnProductPrice * +e.quantityVal * 1000,
            totalAmount: this.getProductPriceAddFree(e) * 1000,
            addedAmount: [
              {
                reason: "RETURN_FEE",
                amount: -Math.abs(this.getProductFreeValue(e) * 1000),
              },
            ],
            lineItemOtherInfo: lineItemOtherInfo,
          };

          // nếu không hoàn tiền thì totalAmount = 0 || check lai logic
          if (!this.refundPolicy) {
            temp.totalAmount = 0;
          }

          e = { ...e, ...temp };
          returnedLineItem.push(e);
        }
      });

      if (returnedLineItem.length > 0) {
        returnedLineItem = this.splitLineItemLoHsdInComponent(_.cloneDeep(returnedLineItem));
      }

      this.loading = true;
      const customer = {
        resId: "",
        displayName: "Khách vãng lai",
        coPartnerId: "",
      };
      if (this.customer.resId) {
        const newCustomer = this.findCustomer(this.customer.resId);
        if (newCustomer) {
          customer.coPartnerId = newCustomer.id;
          customer.displayName = newCustomer.name;
        }
      }

      const params = {
        soOrderId: this.dataItem.id,
        isReceivedItem: this.isReceivedItem,
        returnOrderParams: {
          customerId: customer.coPartnerId,
          customerName: customer.displayName,
          note: this.returnOrderParams.note,
          referenceCode: this.returnOrderParams.referenceCode,
          returnReason:
            this.returnOrderParams.returnReason !== "Khác" ? this.returnOrderParams.returnReason : this.returnReasonOther,
        },
        paymentList,
        addFees: [
          {
            amount: -Math.abs(this.multiplicationThousand(this.getReturnFee)),
            cat: "RETURN_FEE",
            key: "RETURN_FEE",
            name: "Phí trả hàng",
          },
        ],
        returnedLineItem,
      };
      return params;
    },

    async submitForm() {
      if (!this.checkHasQuantity()) return;
      const params = this.getParams();

      try {
        // console.log(333, params);
        // return;
        const response = await OrdersService.createReturnNotExchange(params);
        if (response.success) {
          const gatewayTransactionId = response.data.id;
          this.$router.push({ path: `/orders-return/detail/${gatewayTransactionId}` });
        } else {
          Swal.fire({
            title: "Error",
            text: response.message,
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    splitLineItemLoHsdInComponent(returnedLineItem) {
      let splitLineItemLoHsd = [];
      let spliceItem = [];
      returnedLineItem.map((item) => {
        if (item.useProductBatch) {
          let lineItemTmp = [];
          if (item.batchTmp && item.batchTmp.length > 0) {
            item.batchTmp.map(async (val, index) => {
              lineItemTmp[index] = JSON.parse(JSON.stringify(item));
              const batchCodeItem = {
                batchCode: val.batchCode,
                quantity: val.quantityVal,
                manufactureDate: val.manufactureDate,
                expirationDate: val.expirationDate,
              };
              lineItemTmp[index].lineItemOtherInfo.productBatch = JSON.stringify(batchCodeItem);
              lineItemTmp[index].totalAmount = val.quantityVal * (lineItemTmp[index].totalAmount / lineItemTmp[index].quantity);
              lineItemTmp[index].amount = val.quantityVal * (lineItemTmp[index].amount / lineItemTmp[index].quantity);
              lineItemTmp[index].quantity = val.quantityVal;
            });

            if (lineItemTmp.length > 0) {
              splitLineItemLoHsd.push(...lineItemTmp);
              spliceItem.push(item.lineItemId);
            }
          }
        }
      });

      if (spliceItem.length > 0) {
        spliceItem.map((item) => {
          const getIndex = returnedLineItem.findIndex((val) => val.lineItemId === item);
          if (getIndex != -1) {
            returnedLineItem.splice(getIndex, 1);
          }
        });
        if (splitLineItemLoHsd.length > 0) {
          returnedLineItem.push(...splitLineItemLoHsd);
        }
      }

      return returnedLineItem;
    },
  },

  computed: {
    ...mapGetters("ordersReturn", ["getReturnPrice", "getExchangePrice", "getIsPayWithMpos", "getIsPaying"]),
    ...mapGetters("sell", ["getRmId"]),
    itemPos: {
      get() {
        let index = this.datas.orders.length > 0 ? this.datas.orders.findIndex((item) => item.rm_id == this.getRmId) : -1;
        if (index == -1) {
          index = 0;
          this.SET_RM_ID(index);
        }
        return this.datas.orders[index];
      },
      set(newValue) {
        let index = this.datas.orders.length > 0 ? this.datas.orders.findIndex((item) => item.rm_id == this.getRmId) : -1;
        if (index == -1) {
          index = 0;
          this.SET_RM_ID(index);
        }
        this.datas.orders[index] = newValue;
      },
    },
    getReturnFee() {
      if (this.returnFreeKey == "đ") return 0 - this.returnFreeArr[0].value;
      if (this.returnFreeKey == "%") return 0 - Math.floor((this.returnFreeArr[1].value / 100) * this.getTotalPrice);
      return 0;
    },
    getQuantity() {
      let finalQuantity = 0;
      this.products.forEach((product) => {
        finalQuantity += +product.quantityVal;
      });
      return finalQuantity;
    },

    getTotalPrice() {
      let total = 0;
      for (let i in this.products) {
        total += this.products[i].returnProductPriceAddFree * +this.products[i].quantityVal;
      }
      return Math.floor(total);
    },

    getTotalPriceAddFee() {
      // if (!this.refundPolicy) return 0;
      const result = this.getTotalPrice + this.getReturnFee;
      this.setReturnPrice(result);
      return result;
    },
    getPricePayed() {
      let total = 0;
      this.rePay.forEach((e) => {
        total += e.params.amount;
      });
      return total;
    },

    getPriceWillPay() {
      let result = this.getTotalPriceAddFee - this.getPricePayed;
      if (result < 0) result = 0;
      return result;
    },

    isAddButtonShow() {
      if (this.getTotalPriceAddFee == 0) return false;
      if (this.getPriceWillPay == 0) return false;
      return true;
    },
  },
  watch: {
    getTotalPrice() {
      this.outComeAmount = 0;
      // this.returnFreeArr.forEach((e) => {
      //   e.value = 0;
      // });
    },
    getTotalPriceAddFee() {
      this.outComeAmount = this.getTotalPriceAddFee;
    },
    getReturnPrice() {
      this.checkToDeleteAllReturn("sản phẩm");
    },
    getExchangePrice() {
      this.checkToDeleteAllReturn("sản phẩm");
    },
  },
};
</script>

<style lang="scss">
.repay-table {
  height: 68px;
}
.creat-return-99 {
  .boxContentExt {
    .__card__order-return {
      width: 100%;
      max-width: 960px;
      margin: auto;
      max-width: 960px;
      background: #ffffff;
      -webkit-box-shadow: 0px 0px 12px -4px rgba(0, 0, 0, 0.08), 0px 8px 12px -8px rgba(0, 0, 0, 0.16);
      box-shadow: 0px 0px 12px -4px rgba(0, 0, 0, 0.08), 0px 8px 12px -8px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-box-align: start;
      -ms-flex-align: start;
      align-items: flex-start;
      padding: 24px;
    }
    .__card__order-return_title {
      font-style: normal;
      font-weight: bold !important;
      font-size: 18px;
      line-height: 30px;
      letter-spacing: -0.01em;
      color: #23313e;
    }
    .el-form-item {
      margin-bottom: 15px;
    }
    .return-reason {
      bottom: 8px;
    }
    .el-select {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
    .pay-method {
      bottom: 8px;
    }
    .delete-icon {
      cursor: pointer;
      width: 12px;
    }
    .btn-link {
      margin: 0;
      padding: 0;
      background-color: transparent;
      border: none;
      color: var(--primary) !important;
      text-decoration: none;
    }
    .form-control {
      height: 44px;
    }
    .custom-alert {
      border-color: #ffc043;
      background-color: #fff9ec;
    }
  }
  .popover_custom {
    min-width: 400px;
  }
  .fit-content {
    min-width: fit-content;
  }
  .input-item {
    border: 1px solid #ddd;
    height: 44px;
    width: 60px;
    padding: 8px 5px;
    border-radius: 2px;
  }
  .btn-price {
    cursor: pointer;
    background: none;
    border: 1px solid #ddd;
    width: 100px;
  }
  .btn-popover {
    position: relative;
    background-color: white;
    border: 1px solid #ddd;
    .btn-popover_fee-price {
      display: flex;
      color: #f83939;
      font-size: 11px;

      position: absolute;
      right: 12px;
      bottom: -14px;

      pointer-events: none;
    }
  }

  // add customer
  .option-add-info {
    width: 393px;
    height: 60px;
    padding: 5px 15px;
    box-shadow: inset 0px -1px 0px #e4e4e4;

    .btn-add-info {
      width: 40px;
      height: 40px;
      margin-right: 8px;
      padding-top: 5px;
      background: #ecf0fe;
      border-radius: 4px;
    }
  }
  .el-select-dropdown__item.option-add-item {
    width: 393px;
    height: 60px;
    padding: 5px 15px;
    font-size: 14px;
    box-shadow: inset 0px -1px 0px #e4e4e4;

    p:first-child {
      margin-bottom: 0;
    }

    p:last-child {
      color: #808890;
      margin-bottom: 0;
    }
  }
  .pointed-event-none {
    pointer-events: none;
  }
  .bottom-border {
    width: 100%;
    border-bottom: 1px solid #f2f3f4;
  }
  .search-form {
    position: relative;
    &_icon {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translate(0, -50%);
    }
  }
  .btn-nomarl {
    background-color: #ecf0fe;
  }
  .btn-fix-sỉze {
    height: 44px;
  }

  .search-form .el-input__inner {
    padding-left: 38px;
  }
  .el-input__inner {
    height: 44px;
  }
  .form-control::placeholder {
    color: #bdc1c5;
  }

  .el-input__inner::placeholder {
    color: #bdc1c5;
  }
  .el-button {
    height: 44px;
  }
  .form-control {
    height: 44px;
  }
}
.popover-price-88 {
  .input-money::placeholder {
    color: #bdc1c5;
  }
  .input-money {
    height: 44px;
  }
}

.quick-handle {
  .quick-handle_btn {
    padding: 6px 0px;
    cursor: pointer;
  }
  .quick-handle_btn:hover {
    color: var(--primary);
  }
  .quick-handle_btn:first-child {
    border-bottom: 1px solid #ddd;
  }
}
</style>
